import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {AuthHelper} from './app/common/auth.helper';

if (environment.production) {
  enableProdMode();
}


platformBrowserDynamic().bootstrapModule(AppModule).then(() => {
   // AuthHelper.jQueryAjaxSetup();
    console.info('Angular finished bootstrapping your application!');
  },
  (error) => {
    console.warn('Angular was not able to bootstrap your application.');
    console.error(error);
  }
);




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/main.ts